import React from 'react';
import PropTypes from 'prop-types';

import { getStatus } from '../../../../utils';
import AddAssignee from './components/addAssignee';
import AddBan from './components/addBan';
import FormSummaryRow from '../../../../../../form/formSummaryRow';
import { SummaryRow, SummaryCol } from '../../css';
import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const OrderHeader = ({ orderData, userRights }) => {
  const {
    orderId,
    iotCompanyName,
    iotProductConsoleOrderId,
    iotShippmentTrackingNumber,
    status
  } = orderData;
  const {
    iotOrderDetailsSection: {
      labelOrderId,
      labelBusinessName,
      labelStatus,
      labelAssignee,
      labelBan,
      labelProductConsoleId,
      labelShippingTracking
    }
  } = useLocalizedStringsContext();

  const { finalStatus } = getStatus({ status });

  return (
    <>
      <FormSummaryRow key="orderId" label={labelOrderId} value={orderId} />
      <FormSummaryRow
        key="businessName"
        label={labelBusinessName}
        value={iotCompanyName}
      />
      <FormSummaryRow key="status" label={labelStatus} value={finalStatus} />
      <SummaryRow>
        <SummaryCol>{labelAssignee}</SummaryCol>
        <AddAssignee orderData={orderData} userRights={userRights} />
      </SummaryRow>
      <SummaryRow>
        <SummaryCol>{labelBan}</SummaryCol>
        <AddBan orderData={orderData} userRights={userRights} />
      </SummaryRow>
      <FormSummaryRow
        key="iotProductConsoleOrderId"
        label={labelProductConsoleId}
        value={iotProductConsoleOrderId || 'n/a'}
      />
      <FormSummaryRow
        key="iotShippmentTrackingNumber"
        label={labelShippingTracking}
        value={iotShippmentTrackingNumber || 'n/a'}
      />
    </>
  );
};

OrderHeader.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default OrderHeader;
